import React, { useState } from 'react';
import { Search, Filter, ChevronDown, Calendar, Download, FileText, FolderOpen, File, Archive, Clock, Tag, Trash2, RefreshCw, CheckCircle, AlertCircle } from 'lucide-react';
import { DepartmentSelector } from './DepartmentSelector';
import { DocumentViewer } from './DocumentViewer';
export const ArchiveManagement = ({
  activeDepartment,
  setActiveDepartment
}) => {
  const [activeTab, setActiveTab] = useState('documents');
  const [viewMode, setViewMode] = useState('grid');
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [isRestoreModalOpen, setIsRestoreModalOpen] = useState(false);
  const [documentToRestore, setDocumentToRestore] = useState(null);
  const openDocumentViewer = document => {
    setSelectedDocument(document);
  };
  const closeDocumentViewer = () => {
    setSelectedDocument(null);
  };
  const handleRestoreDocument = document => {
    setDocumentToRestore(document);
    setIsRestoreModalOpen(true);
  };
  const filteredDocuments = archivedDocuments.filter(doc => {
    const matchesSearch = searchQuery === '' || doc.name.toLowerCase().includes(searchQuery.toLowerCase());
    if (activeTab === 'documents') return matchesSearch && doc.type !== 'Folder';
    if (activeTab === 'folders') return matchesSearch && doc.type === 'Folder';
    return matchesSearch;
  });
  return <div className="p-6" data-id="element-34">
      <div className="flex justify-between items-center mb-6" data-id="element-35">
        <div className="flex items-center space-x-4" data-id="element-36">
          <h1 className="text-2xl font-bold text-gray-800" data-id="element-37">Archive</h1>
          <DepartmentSelector activeDepartment={activeDepartment} setActiveDepartment={setActiveDepartment} data-id="element-38" />
        </div>
        <div className="flex items-center space-x-3" data-id="element-39">
          <button className="px-4 py-2 bg-blue-600 text-white rounded-md flex items-center space-x-2 hover:bg-blue-700 transition-colors" data-id="element-40">
            <RefreshCw className="h-4 w-4" data-id="element-41" />
            <span data-id="element-42">Refresh</span>
          </button>
          <div className="flex border border-gray-300 rounded-md overflow-hidden" data-id="element-43">
            <button className={`px-3 py-2 ${viewMode === 'grid' ? 'bg-gray-100' : 'bg-white'}`} onClick={() => setViewMode('grid')} data-id="element-44">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-45">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" data-id="element-46" />
              </svg>
            </button>
            <button className={`px-3 py-2 ${viewMode === 'list' ? 'bg-gray-100' : 'bg-white'}`} onClick={() => setViewMode('list')} data-id="element-47">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-48">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" data-id="element-49" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div className="flex items-center space-x-6 border-b border-gray-200 mb-6" data-id="element-50">
        <button className={`py-3 px-1 ${activeTab === 'documents' ? 'text-blue-600 border-b-2 border-blue-600 font-medium' : 'text-gray-600'}`} onClick={() => setActiveTab('documents')} data-id="element-51">
          Archived Documents
        </button>
        <button className={`py-3 px-1 ${activeTab === 'folders' ? 'text-blue-600 border-b-2 border-blue-600 font-medium' : 'text-gray-600'}`} onClick={() => setActiveTab('folders')} data-id="element-52">
          Archived Folders
        </button>
        <button className={`py-3 px-1 ${activeTab === 'retention' ? 'text-blue-600 border-b-2 border-blue-600 font-medium' : 'text-gray-600'}`} onClick={() => setActiveTab('retention')} data-id="element-53">
          Retention Policies
        </button>
      </div>

      <div className="flex justify-between items-center mb-6" data-id="element-54">
        <div className="relative w-96" data-id="element-55">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" data-id="element-56" />
          <input type="text" placeholder="Search archives..." className="pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-57" />
        </div>
        <div className="flex items-center space-x-4" data-id="element-58">
          <button className="flex items-center space-x-2 px-3 py-2 border border-gray-300 rounded-md text-gray-700" data-id="element-59">
            <Filter className="h-4 w-4" data-id="element-60" />
            <span data-id="element-61">Filters</span>
            <ChevronDown className="h-4 w-4" data-id="element-62" />
          </button>
          <button className="flex items-center space-x-2 px-3 py-2 border border-gray-300 rounded-md text-gray-700" data-id="element-63">
            <Calendar className="h-4 w-4" data-id="element-64" />
            <span data-id="element-65">Archive Date</span>
            <ChevronDown className="h-4 w-4" data-id="element-66" />
          </button>
        </div>
      </div>

      {activeTab !== 'retention' ? viewMode === 'grid' ? <div className="grid grid-cols-4 gap-6" data-id="element-67">
            {filteredDocuments.map(doc => <div key={doc.id} onClick={() => doc.type !== 'Folder' ? openDocumentViewer(doc) : null} className="cursor-pointer" data-id="element-68">
                <ArchiveCard document={doc} onRestore={() => handleRestoreDocument(doc)} data-id="element-69" />
              </div>)}
          </div> : <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-70">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-71">
              <thead className="bg-gray-50" data-id="element-72">
                <tr data-id="element-73">
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-74">
                    Name
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-75">
                    Type
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-76">
                    Archive Date
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-77">
                    Size
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-78">
                    Retention
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-79">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-80">
                {filteredDocuments.map(doc => <tr key={doc.id} className="hover:bg-gray-50" data-id="element-81">
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-82">
                      <div className="flex items-center" data-id="element-83">
                        <div className="flex-shrink-0 h-10 w-10 bg-gray-100 rounded-md flex items-center justify-center" data-id="element-84">
                          {getDocumentIcon(doc.type)}
                        </div>
                        <div className="ml-4" data-id="element-85">
                          <div className="text-sm font-medium text-gray-900 cursor-pointer hover:text-blue-600" onClick={() => doc.type !== 'Folder' ? openDocumentViewer(doc) : null} data-id="element-86">
                            {doc.name}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-87">
                      {doc.type}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-88">
                      {doc.archivedDate}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-89">
                      {doc.size}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-90">
                      {doc.retention}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-91">
                      <button className="text-blue-600 hover:text-blue-900 mr-3" onClick={() => doc.type !== 'Folder' ? openDocumentViewer(doc) : null} data-id="element-92">
                        View
                      </button>
                      <button className="text-green-600 hover:text-green-900 mr-3" onClick={() => handleRestoreDocument(doc)} data-id="element-93">
                        Restore
                      </button>
                      <button className="text-gray-600 hover:text-gray-900" data-id="element-94">
                        <Download className="h-4 w-4" data-id="element-95" />
                      </button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div> : <RetentionPoliciesSection data-id="element-96" />}

      {/* Document Viewer Modal */}
      {selectedDocument && <DocumentViewer document={selectedDocument} onClose={closeDocumentViewer} data-id="element-97" />}

      {/* Restore Confirmation Modal */}
      {isRestoreModalOpen && documentToRestore && <RestoreConfirmationModal document={documentToRestore} onClose={() => setIsRestoreModalOpen(false)} onConfirm={() => {
      // Here you would handle the restore logic
      console.log('Restoring document:', documentToRestore);
      setIsRestoreModalOpen(false);
    }} data-id="element-98" />}
    </div>;
};
const ArchiveCard = ({
  document,
  onRestore
}) => {
  return <div className="bg-white rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-shadow" data-id="element-99">
      <div className="h-32 bg-gray-100 flex items-center justify-center" data-id="element-100">
        {getDocumentIcon(document.type, 'h-16 w-16 text-gray-400')}
      </div>
      <div className="p-4" data-id="element-101">
        <h3 className="font-medium text-gray-800 mb-1 truncate" data-id="element-102">
          {document.name}
        </h3>
        <div className="flex justify-between items-center mb-2" data-id="element-103">
          <span className="text-xs text-gray-500" data-id="element-104">{document.archivedDate}</span>
          <span className="text-xs text-gray-500" data-id="element-105">{document.size}</span>
        </div>
        <div className="flex justify-between items-center" data-id="element-106">
          <span className="text-xs text-gray-500" data-id="element-107">
            Retention: {document.retention}
          </span>
          <button className="text-xs text-green-600 hover:text-green-800 flex items-center" onClick={e => {
          e.stopPropagation();
          onRestore();
        }} data-id="element-108">
            <RefreshCw className="h-3 w-3 mr-1" data-id="element-109" />
            Restore
          </button>
        </div>
      </div>
    </div>;
};
const RetentionPoliciesSection = () => {
  return <div className="space-y-6" data-id="element-110">
      <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-111">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-112">
          <thead className="bg-gray-50" data-id="element-113">
            <tr data-id="element-114">
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-115">
                Policy Name
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-116">
                Document Types
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-117">
                Retention Period
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-118">
                Auto Delete
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-119">
                Status
              </th>
              <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-120">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-121">
            {retentionPolicies.map(policy => <tr key={policy.id} className="hover:bg-gray-50" data-id="element-122">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-123">
                  <div className="text-sm font-medium text-gray-900" data-id="element-124">
                    {policy.name}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-125">
                  <div className="flex flex-wrap gap-1" data-id="element-126">
                    {policy.documentTypes.map((type, index) => <span key={index} className="px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-800" data-id="element-127">
                        {type}
                      </span>)}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-128">
                  {policy.retentionPeriod}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-129">
                  {policy.autoDelete ? 'Yes' : 'No'}
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-130">
                  <span className={`px-2 py-1 text-xs rounded-full ${policy.active ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-131">
                    {policy.active ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-132">
                  <button className="text-blue-600 hover:text-blue-900 mr-3" data-id="element-133">
                    Edit
                  </button>
                  <button className="text-red-600 hover:text-red-900" data-id="element-134">
                    Delete
                  </button>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4" data-id="element-135">
        <div className="flex items-start" data-id="element-136">
          <AlertCircle className="h-5 w-5 text-blue-500 mt-0.5 mr-3" data-id="element-137" />
          <div data-id="element-138">
            <h4 className="text-sm font-medium text-blue-800" data-id="element-139">
              About Retention Policies
            </h4>
            <p className="text-sm text-blue-700 mt-1" data-id="element-140">
              Retention policies determine how long documents are kept in the
              archive before being permanently deleted. Configure policies based
              on document types and regulatory requirements.
            </p>
          </div>
        </div>
      </div>
      <div className="flex justify-end" data-id="element-141">
        <button className="px-4 py-2 bg-blue-600 text-white rounded-md flex items-center space-x-2 hover:bg-blue-700 transition-colors" data-id="element-142">
          <Plus className="h-4 w-4" data-id="element-143" />
          <span data-id="element-144">Create New Policy</span>
        </button>
      </div>
    </div>;
};
const RestoreConfirmationModal = ({
  document,
  onClose,
  onConfirm
}) => {
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center" data-id="element-145">
      <div className="bg-white w-full max-w-md rounded-lg shadow-xl overflow-hidden" data-id="element-146">
        <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between" data-id="element-147">
          <h2 className="text-lg font-semibold text-gray-800" data-id="element-148">
            Restore Document
          </h2>
          <button className="text-gray-500 hover:text-gray-700" onClick={onClose} data-id="element-149">
            <X className="h-5 w-5" data-id="element-150" />
          </button>
        </div>
        <div className="p-6" data-id="element-151">
          <div className="flex items-center mb-4" data-id="element-152">
            <div className="h-12 w-12 bg-green-100 rounded-full flex items-center justify-center text-green-600 mr-4" data-id="element-153">
              <RefreshCw className="h-6 w-6" data-id="element-154" />
            </div>
            <div data-id="element-155">
              <h3 className="text-lg font-medium text-gray-900" data-id="element-156">
                Confirm Restoration
              </h3>
              <p className="text-sm text-gray-500 mt-1" data-id="element-157">
                Are you sure you want to restore this document from the archive?
              </p>
            </div>
          </div>
          <div className="bg-gray-50 rounded-lg p-4 mb-4" data-id="element-158">
            <div className="flex items-center" data-id="element-159">
              <div className="h-10 w-10 bg-gray-100 rounded-md flex items-center justify-center mr-3" data-id="element-160">
                {getDocumentIcon(document.type)}
              </div>
              <div data-id="element-161">
                <p className="text-sm font-medium text-gray-800" data-id="element-162">
                  {document.name}
                </p>
                <p className="text-xs text-gray-500 mt-1" data-id="element-163">
                  {document.type} • {document.size} • Archived on{' '}
                  {document.archivedDate}
                </p>
              </div>
            </div>
          </div>
          <div className="space-y-3" data-id="element-164">
            <div className="flex items-start" data-id="element-165">
              <CheckCircle className="h-5 w-5 text-green-500 mt-0.5 mr-3" data-id="element-166" />
              <p className="text-sm text-gray-600" data-id="element-167">
                The document will be moved back to the active documents section
              </p>
            </div>
            <div className="flex items-start" data-id="element-168">
              <CheckCircle className="h-5 w-5 text-green-500 mt-0.5 mr-3" data-id="element-169" />
              <p className="text-sm text-gray-600" data-id="element-170">
                All document metadata and version history will be preserved
              </p>
            </div>
          </div>
        </div>
        <div className="px-6 py-4 border-t border-gray-200 flex justify-end space-x-3" data-id="element-171">
          <button className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors" onClick={onClose} data-id="element-172">
            Cancel
          </button>
          <button className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors" onClick={onConfirm} data-id="element-173">
            Restore Document
          </button>
        </div>
      </div>
    </div>;
};
// Helper functions
const getDocumentIcon = (type, className = 'h-6 w-6 text-gray-500') => {
  switch (type) {
    case 'PDF':
      return <FileText className={className} data-id="element-174" />;
    case 'Folder':
      return <FolderOpen className={className} data-id="element-175" />;
    case 'Document':
      return <File className={className} data-id="element-176" />;
    case 'Archive':
      return <Archive className={className} data-id="element-177" />;
    default:
      return <File className={className} data-id="element-178" />;
  }
};
// Sample data
const archivedDocuments = [{
  id: 1,
  name: 'Budget 2022.pdf',
  type: 'PDF',
  archivedDate: 'Jun 15, 2023',
  size: '4.1 MB',
  retention: '7 years (until 2030)',
  status: 'Archived'
}, {
  id: 2,
  name: 'Employee Handbook 2021',
  type: 'Document',
  archivedDate: 'Mar 20, 2023',
  size: '2.3 MB',
  retention: '5 years (until 2028)',
  status: 'Archived'
}, {
  id: 3,
  name: 'Old Projects',
  type: 'Folder',
  archivedDate: 'Feb 10, 2023',
  size: '78 MB',
  retention: '10 years (until 2033)',
  status: 'Archived'
}, {
  id: 4,
  name: 'Q1 Financial Report 2022.pdf',
  type: 'PDF',
  archivedDate: 'Apr 15, 2023',
  size: '3.7 MB',
  retention: '7 years (until 2030)',
  status: 'Archived'
}, {
  id: 5,
  name: 'Marketing Campaign 2021.pdf',
  type: 'PDF',
  archivedDate: 'Dec 28, 2022',
  size: '5.2 MB',
  retention: '3 years (until 2025)',
  status: 'Archived'
}, {
  id: 6,
  name: 'Old Contracts',
  type: 'Folder',
  archivedDate: 'Jan 05, 2023',
  size: '120 MB',
  retention: '15 years (until 2038)',
  status: 'Archived'
}, {
  id: 7,
  name: 'Company Policies 2020',
  type: 'Document',
  archivedDate: 'Nov 10, 2022',
  size: '1.8 MB',
  retention: '10 years (until 2032)',
  status: 'Archived'
}, {
  id: 8,
  name: 'Training Materials 2021',
  type: 'Document',
  archivedDate: 'Aug 22, 2022',
  size: '45 MB',
  retention: '5 years (until 2027)',
  status: 'Archived'
}];
const retentionPolicies = [{
  id: 1,
  name: 'Financial Documents',
  documentTypes: ['PDF', 'Excel', 'Financial Reports'],
  retentionPeriod: '7 years',
  autoDelete: false,
  active: true
}, {
  id: 2,
  name: 'HR Documents',
  documentTypes: ['PDF', 'Word', 'Employee Records'],
  retentionPeriod: '5 years',
  autoDelete: false,
  active: true
}, {
  id: 3,
  name: 'Legal Contracts',
  documentTypes: ['PDF', 'Word', 'Contracts'],
  retentionPeriod: '15 years',
  autoDelete: false,
  active: true
}, {
  id: 4,
  name: 'Marketing Materials',
  documentTypes: ['PDF', 'Image', 'Presentations'],
  retentionPeriod: '3 years',
  autoDelete: true,
  active: true
}, {
  id: 5,
  name: 'Internal Memos',
  documentTypes: ['PDF', 'Word', 'Email Archives'],
  retentionPeriod: '2 years',
  autoDelete: true,
  active: false
}];